import React from "react";

import styles from './Loader.module.css'

interface Props {
}

export const Loader: React.FC<Props & React.HTMLAttributes<HTMLButtonElement>> = () => {
    return <span  className={styles.loader}></span>
}